import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=2337cae8&scoped=true"
import script from "./OrderTypeSelect.ts?vue&type=script&lang=ts&external"
export * from "./OrderTypeSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./OrderTypeSelect.scss?vue&type=style&index=0&id=2337cae8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337cae8",
  null
  
)

export default component.exports